
import { Suspense as ReactSuspense, useEffect } from 'react';
import OnlineWizard from 'screens/OnlineWizard';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { Route, Routes } from 'react-router-dom';
import { OnlineBookingShell } from 'shell';
import * as Screens from 'screens';
import { ErrorBoundary } from 'react-error-boundary';
import { Loader } from 'components';

export const Suspense = ({ children }) => <ReactSuspense fallback={<Loader />}>{children}</ReactSuspense>

const Error = () => <Suspense><Screens.Error /></Suspense>

function ComponentWithRecaptcha({ recaptchaSiteKey, recaptchaState, lngCode, children }) {
  return recaptchaSiteKey && recaptchaState
    ? <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} language={lngCode} useEnterprise={false} children={children} />
    : children;
}

const App = (props) => {
  const loc = useLocation();
  //on reload clears location cached info
  useEffect(() => {
    window.history.replaceState({}, document.title)
    console.info("End User. Version: 2.0.0");
  }, []);

  const urls = (props?.urls || [])
  const navigateFrom = (document.referrer || '')
  if (urls.length && !urls.some((x) => navigateFrom.startsWith(x))) {
    console.log('Your site is not allowed to use this application')
    return <Error />
  }


  if (loc?.state?.error === 404) { return <Error /> }

  const { recaptchaSiteKey, language: { lngCode }, recaptchaState } = props;

  return (
    <ComponentWithRecaptcha {...{ recaptchaSiteKey, lngCode, recaptchaState }}>
      <Routes>
        <Route path='/:journeyGuidFromUrl' element={(
          <OnlineBookingShell {...props}>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <OnlineWizard />
            </ErrorBoundary>
          </OnlineBookingShell>)}
        />
        <Route path="*" element={<Error />} />
      </Routes>
    </ComponentWithRecaptcha>
  );
};

export default connect(
  ({ current: { general: { language, recaptchaState } } }) => ({ language, recaptchaState }))
  (App);

function ErrorFallback({ error }) {
  const devEnvironment = process.env.NODE_ENV === 'development';
  return (
    <>
      {devEnvironment && <div role="alert" style={{ position: "absolute" }}> <pre>{error.message}</pre> </div>}
      <Error />
    </>
  )
}


function hideConsoleLogs() {
  //hides all console.logs in production
  if (process.env.NODE_ENV === 'production') {
    console.log = () => { };
    // console.error = () => {};
    // console.debug = () => {};
  }
}

hideConsoleLogs();